// Reads the sizes react-resizable-panels persisted for an `autoSaveId`
// (localStorage "react-resizable-panels:<id>" -> { <panelKey>: { layout } }),
// in DOM order. Returns `fallback` unless a saved layout of `count` panels
// exists, so skeletons can mirror what the user last dragged the panes to.
export const readSavedPanelLayout = (autoSaveId, count = 2, fallback = null) => {
  try {
    const saved = JSON.parse(
      localStorage.getItem(`react-resizable-panels:${autoSaveId}`) || "null"
    );
    const match = Object.values(saved || {}).find(
      ({ layout } = {}) =>
        Array.isArray(layout) &&
        layout.length === count &&
        layout.every((size) => Number.isFinite(size) && size > 0)
    );
    return match ? match.layout : fallback;
  } catch {
    return fallback;
  }
};
